import { createContext } from 'react'

const PurchaseOrderContext = createContext()

export default PurchaseOrderContext
